/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Schema for a DIDComm message descriptor used in batch creation. It contains metadata about the message and its attachments.
 */
export interface DidCommMessageBlobDescriptor {
    attachments: Truvity.DidCommMessageBlobAttachmentDescriptor[];
    /** The ID that returned on Upload operation in blob_id field. */
    blobId: string;
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    createdAt: Date;
    /** The DID according to [3.1 DID Syntax](https://www.w3.org/TR/did-core/#did-syntax) of [Decentralized Identifiers (DIDs) v1.0](https://www.w3.org/TR/did-core). */
    from: string;
    /**
     * The primary and unique identifier of the resource (inside tenant)
     * according to [RFC 4122](https://www.rfc-editor.org/info/rfc4122).
     */
    id: string;
    thid?: string;
    /** The DID according to [3.1 DID Syntax](https://www.w3.org/TR/did-core/#did-syntax) of [Decentralized Identifiers (DIDs) v1.0](https://www.w3.org/TR/did-core). */
    to: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    uploadUri: string;
}
